<form (ngSubmit)="onSubmit()" #filtroForm="ngForm">
    <label class="center-block">
        Frota
    </label>
    <div class="input-group">
        
        <input [(ngModel)]="filtro.parametro"
            type="text" name="frota" class="form-control input" 
            style="min-width: 200px;"
            matTooltip="Preecha para a pesquisa da Frota" 
            (ngModelChange)="search$.next($event)" 
            [matAutocomplete]="auto"
            placeholder="digite aqui" />
        <mat-autocomplete #auto="matAutocomplete"  (optionSelected)='getPosts($event.option.value)' [displayWith]="displayFn">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                {{option.busca}}
            </mat-option>
        </mat-autocomplete>
        <button type="submit" mat-icon-button style="margin-left: 10px" matTooltip="Pesquise a Frota">
            <mat-icon aria-hidden="false" aria-label="Pesquise a Frota" fontIcon="search">
            </mat-icon>
        </button>
        <button type="button" mat-icon-button style="margin-left: 10px" matTooltip="Limpe o resultado da pesquisa de Frota"
            (click) = "limpaFiltro()">
            <mat-icon aria-hidden="false" aria-label="Limpe o resultado da pesquisa de Frota" fontIcon="delete">
            </mat-icon>
        </button>
    </div>
</form>
<div *ngIf="filtro.frota" class="supercombo-selecionado panel panel-info">
    <div class="panel-body">
        <div class="row">
            <div class="col-md-3">
                <label>
                    Cód da Frota
                </label>
            </div>
            <div class="col-md-5">
                <label>
                    Nome Fantasia
                </label>
            </div>
            <div class="col-md-3">
                <label>
                    Cidade
                </label>
            </div>
            <div class="col-md-1">
                <label>
                    UF
                </label>
            </div>
        </div>
        <div class="row dados">
            <div class="col-md-3 ">
                <span class="mat-cell">{{ filtro.frota.codigo }}</span>
            </div>
            <div class="col-md-5 ">
                <span class="mat-cell">{{ filtro.frota.nomeReduzido }}</span>
            </div>
            <div class="col-md-3 ">
                <span class="mat-cell">{{ filtro.frota.municipio }}</span>
            </div>
            <div class="col-md-1 ">
                <span class="mat-cell">{{ filtro.frota.estado }}</span>
            </div>
        </div>
    </div>
</div>